// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"708":"196f2440","2935":"fa0bbb68","6155":"35d46e80","8323":"196f2440","8986":"ea3db241"}[chunkId] + ".chunk.css";
};